import { render } from "./Horizontal.vue?vue&type=template&id=7fa24b83&ts=true"
import script from "./Horizontal.vue?vue&type=script&lang=ts"
export * from "./Horizontal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\Mbf5_HCC\\XaQuangHa\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__